/* NDM custom JS: search pill in filter bar + demote sold-out/$0 products + English facet labels */
(function () {
  function openSearch() {
    var t = document.querySelector('header button[aria-label="Search"], .header-actions__action[aria-label="Search"]');
    if (t) t.click();
  }

  function makePill() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ndm-facets-search';
    b.setAttribute('aria-label', 'Search products');
    b.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line></svg>' +
      '<span>Search…</span>';
    b.addEventListener('click', openSearch);
    return b;
  }

  function initSearch() {
    try {
      var bars = document.querySelectorAll('.facets-block-wrapper--horizontal .facets__filters-wrapper');
      bars.forEach(function (bar) {
        if (!bar.querySelector('.ndm-facets-search')) bar.appendChild(makePill());
      });
    } catch (e) { /* noop */ }
  }

  /* --- facet labels in English (app config is Spanish) --- */
  var LABELS = { 'Marca': 'Brand', 'Tipo de producto': 'Product type', 'Precio': 'Price', 'Disponibilidad': 'Availability' };
  function renameLabels() {
    try {
      document.querySelectorAll('.facets__label').forEach(function (el) {
        var t = el.textContent.trim();
        if (LABELS[t]) el.textContent = LABELS[t];
      });
    } catch (e) { /* noop */ }
  }

  /* --- demote sold-out and $0.00 products to the end of each grid page ---
     NDM 2026-10-09: reorder WITHIN each loaded page (data-page) only. Moving items across
     pages made cards jump while infinite scroll appended new pages. */
  var demoting = false;
  function isDemotable(li) {
    var badges = li.querySelectorAll('.product-badges__badge');
    for (var i = 0; i < badges.length; i++) {
      if (/sold\s*out|agotado/i.test(badges[i].textContent)) return true;
    }
    return /\$\s*0\.00(?!\d)/.test(li.textContent);
  }
  function demote() {
    if (demoting) return;
    demoting = true;
    try {
      document.querySelectorAll('ul.product-grid').forEach(function (grid) {
        var items = Array.prototype.slice.call(grid.children).filter(function (c) { return c.tagName === 'LI'; });
        var groups = {}, order = [];
        items.forEach(function (li) {
          var p = li.getAttribute('data-page') || '0';
          if (!groups[p]) { groups[p] = []; order.push(p); }
          groups[p].push(li);
        });
        order.forEach(function (p, gi) {
          var g = groups[p];
          var bad = g.filter(isDemotable);
          if (!bad.length) return;
          var lastGood = -1, firstBad = g.length;
          g.forEach(function (it, idx) {
            if (bad.indexOf(it) === -1) { if (idx > lastGood) lastGood = idx; }
            else if (idx < firstBad) firstBad = idx;
          });
          if (firstBad > lastGood) return; /* already at the end of this page */
          var anchor = gi + 1 < order.length ? groups[order[gi + 1]][0] : null;
          bad.forEach(function (li) { grid.insertBefore(li, anchor); });
        });
      });
    } catch (e) { /* noop */ }
    demoting = false;
  }

  function init() {
    initSearch();
    renameLabels();
    demote();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* facets/grid re-render on filter, sort or pagination: re-apply */
  try {
    var pending = null;
    new MutationObserver(function () {
      if (demoting) return;
      if (pending) clearTimeout(pending);
      pending = setTimeout(init, 150);
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* noop */ }
})();
